<div class="activity-details single">
    <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
</div>